// helper to map document category to the respective icon file name / file reference
// ... or file extension to respective icon file name / file reference

const MIME_ICONS = {
  software: ["exe"],
  picture: ["jpg", "jpeg", "png", "gif", "tif", "tiff", "bmp", "dwg"],
  code: ["xml", "xsd", "json", "html", "js", "rb", "java", "py", "c"],
  text: ["txt", "rtf", "doc", "docx"],
  certificate: ["der", "cer"],
  tables: ["csv", "xls", "xlsx", "xlsxm", "numbers"],
  compressed: ["zip", "rar"],
  pdf: ["pdf"],
};

const CATEGORY_ICONS = [
  "certificate",
  "report",
  "manual",
  "other",
  "picture",
  "software",
];

const EXTENSION_MAPPING = {};

Object.keys(MIME_ICONS).forEach((key) => {
  // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  MIME_ICONS[key].forEach((extension: $TSFixMe) => {
    // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    EXTENSION_MAPPING[extension] = key;
  });
});

export function iconForFileName(fileName: $TSFixMe) {
  const extension = fileName.split(".").pop().toLowerCase();
  // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  return EXTENSION_MAPPING[extension]
    ? // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      `lcm-iot-icon-${EXTENSION_MAPPING[extension]}`
    : "lcm-iot-icon-other";
}

export function iconForFileCategory(categoryCode: $TSFixMe) {
  return CATEGORY_ICONS.includes(categoryCode)
    ? `lcm-iot-icon-${categoryCode}`
    : "lcm-iot-icon-other";
}
